export class DismissedMessage {
    key: string;
    dismissedUntil?: Date;

    constructor(key: string, dismissedUntil?: Date | string) {
        this.key = key;
        if (dismissedUntil !== undefined) {
            if (dismissedUntil instanceof Date) {
                this.dismissedUntil = dismissedUntil;
            } else {
                this.dismissedUntil = new Date(dismissedUntil);
            }
        }
    }
}
